import { render, staticRenderFns } from "./FichaAvaliadoresValidadores.vue?vue&type=template&id=18ef0b64&"
import script from "./FichaAvaliadoresValidadores.vue?vue&type=script&lang=js&"
export * from "./FichaAvaliadoresValidadores.vue?vue&type=script&lang=js&"
import style0 from "./FichaAvaliadoresValidadores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports